import React from 'react';
import {useTotalPreview} from '../../../data/hooks/preview';
import {useConditions} from '../../../data/hooks/query';
import {useString} from '../../../data/hooks/strings';
import LayoutColumns from '../LayoutColumns/LayoutColumns';

function Header(props) {
    const {} = props,
        size = useConditions().length,
        prompt = useString('prompt'),
        emptyPrompt = useString('emptyPrompt'),
        totalPreview = useTotalPreview();

    if (!size) return <h3>{emptyPrompt ?? prompt}</h3>;

    return (
        <LayoutColumns count={totalPreview}>
            <h3>{prompt}</h3>
        </LayoutColumns>
    );
}

export default Header;
